import React, {useMemo} from 'react';
import {View, StyleSheet} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import Localized from 'src/constants/AppStrings';
import CheckIcon from 'src/components/img/svg/CheckIcon';
import Styles from '../../Styles';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import AccountConstants from 'src/constants/AccountConstants';
import {RewardPolicyType} from 'src/types/Rewards';

const RewardsCompleteButton = ({
  isCompleted,
  currentStatus,
  policyType,
  onPress,
}: {
  isCompleted?: boolean;
  currentStatus?: string;
  policyType?: string;
  onPress: () => void;
}) => {
  const iconColor =
    getButtonDescriber()
      .roundAppButtonOutlineTextStyle(false)
      ?.color?.toString() ?? getLayoutDescriber().bottomTabBtnColor();

  const isProcessing = useMemo(() => {
    return (
      currentStatus === AccountConstants.INITIATED ||
      currentStatus === AccountConstants.PROCESSING
    );
  }, [currentStatus]);

  const getProgressStatus = () => {
    if (isProcessing) {
      return Localized.Labels.in_process;
    }

    if (policyType === RewardPolicyType.PURCHASE_STREAK) {
      return Localized.Labels.rewards_more_info_label;
    }

    return Localized.Labels.complete;
  };

  const progressStatus = getProgressStatus();

  if (isCompleted) {
    return (
      <RoundedAppButton
        buttonType={RoundedAppButtonType.Outline}
        titleText={Localized.Labels.completed}
        inActiveButtonViewStyle={styles.completedButtonView}
        buttonContainerStyle={styles.buttonContainer}
        isDisabled
        buttonIcon={
          <View style={styles.buttonIconView}>
            <CheckIcon
              color={iconColor}
              width={Styles.Spacing.m3}
              height={Styles.Spacing.m3}
            />
          </View>
        }
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      />
    );
  }

  return (
    <RoundedAppButton
      buttonType={RoundedAppButtonType.Outline}
      titleText={progressStatus}
      buttonViewStyle={styles.completeButtonView}
      buttonContainerStyle={styles.buttonContainer}
      onPress={onPress}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      inActiveButtonViewStyle={styles.inactiveProcessButtonView}
      isDisabled={isProcessing}
      inActiveTextStyle={styles.inactiveProcessTextView}
    />
  );
};

const styles = StyleSheet.create({
  completedButtonView: {
    minHeight: Styles.Spacing.m4,
    borderWidth: 0,
  },
  buttonContainer: {
    marginBottom: -6,
    alignSelf: 'center',
  },
  buttonIconView: {
    marginBottom: -2,
    marginRight: -4,
  },
  completeButtonView: {
    minHeight: Styles.Spacing.m4,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  inactiveProcessButtonView: {
    minHeight: Styles.Spacing.m4,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    backgroundColor: Styles.Colors.PayNew.neutralHuesBase10,
    borderColor: Styles.footerTabInactive,
  },
  inactiveProcessTextView: {
    color: Styles.footerTabInactive,
    fontSize: Styles.Fonts.f0,
  },
});

export default RewardsCompleteButton;
